export enum Events {
  AuthToken = 'authToken',
  Language = 'language',
}
